import React from 'react'

import {ROUTES} from 'constants/routes.constant'

// GreetingLanding renders an app-download CTA — used both for the explicit
// /greeting URL and as the desktop fallback for all deep-link paths the
// Flutter app claims via Universal/App Links.
const GreetingLanding = React.lazy(() => import('views/GreetingLanding'))

const externalRoutes = [
    {
        key: 'termsOfUse',
        path: ROUTES.TERM_OF_USE,
        component: React.lazy(() => import('views/TermsOfUse')),
    },
    {
        key: 'privacyPolicy',
        path: ROUTES.PRIVACY_POLICY,
        component: React.lazy(() => import('views/PrivacyPolicy')),
    },
    {
        key: 'greetingLanding',
        path: ROUTES.GREETING,
        component: GreetingLanding,
    },
    // Deep-link fallbacks — render GreetingLanding (download CTA) for desktop
    // users who tap a Universal/App Link without the app installed.
    {key: 'deepLinkWorkout', path: ROUTES.DEEP_LINK_WORKOUT, component: GreetingLanding},
    {key: 'deepLinkProgram', path: ROUTES.DEEP_LINK_PROGRAM, component: GreetingLanding},
    {key: 'deepLinkClub', path: ROUTES.DEEP_LINK_CLUB, component: GreetingLanding},
    {key: 'deepLinkEvent', path: ROUTES.DEEP_LINK_EVENT, component: GreetingLanding},
    {key: 'deepLinkProfile', path: ROUTES.DEEP_LINK_PROFILE, component: GreetingLanding},
    {key: 'deepLinkShare', path: ROUTES.DEEP_LINK_SHARE, component: GreetingLanding},
    {key: 'deepLinkResetPassword', path: ROUTES.DEEP_LINK_RESET_PASSWORD, component: GreetingLanding},
]

export default externalRoutes
